import React, { useRef } from 'react';
import { IoCalendarSharp } from 'react-icons/io5';

const DatePicker = ({ selectedDate, setSelectedDate, disabled = false }) => {
  const dateInputRef = useRef(null);

  const formattedDate = selectedDate
    ? new Date(`${selectedDate}T00:00:00`).toLocaleDateString('en-GB', {
        weekday: 'short',
        day: 'numeric',
        month: 'short',
        year: 'numeric',
      })
    : '';

  const openDatePicker = () => {
    if (dateInputRef.current?.showPicker) {
      dateInputRef.current.showPicker();
    } else {
      dateInputRef.current?.click();
    }
  };

  return (
    <div className="relative">
      <button
        type="button"
        disabled={disabled}
        onClick={openDatePicker}
        className="flex items-center gap-2 rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm hover:bg-slate-50"
      >
        <IoCalendarSharp />
        <span>{formattedDate}</span>
      </button>

      <input
        ref={dateInputRef}
        type="date"
        aria-label="Select date"
        disabled={disabled}
        value={selectedDate}
        onChange={(e) => setSelectedDate(e.target.value)}
        className="pointer-events-none absolute opacity-0"
      />
    </div>
  );
};

export default DatePicker;